import React from 'react';
import Select from 'react-select';
import _ from 'lodash';
type OptionsFilterProps = {
  multi?: boolean;
  clearable?: boolean;
  ignoreCase?: boolean;
  field?: string;
  value?: string | any[] | boolean;
  placeholder?: string;
  onChange: (...args: any[]) => any;
  noResultsText?: string;
  options: any[];
};
const OptionsFilter: React.SFC<OptionsFilterProps> = props => {
  const {
    value = [],
    field,
    placeholder = '',
    options,
    multi,
    clearable,
    noResultsText = 'No results found',
    ignoreCase = true,
  } = props;
  let adjustedValue = value;
  if (_.isArray(value)) {
    adjustedValue = value.join(',');
  }
  function handleChange(val) {
    if (field) {
      props.onChange(field, val);
    } else {
      props.onChange(val);
    }
  }
  return (
    <div>
      <Select
        name={`${field}-filter`}
        value={adjustedValue}
        simpleValue
        delimiter=","
        options={options}
        onChange={handleChange}
        multi={multi}
        placeholder={placeholder}
        clearable={clearable}
        noResultsText={noResultsText}
        ignoreCase={ignoreCase}
      />
    </div>
  );
};
export default OptionsFilter;
